var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c(_vm.resolver[_vm.level],{tag:"component",style:({ color: _vm.color }),domProps:{"innerHTML":_vm._s(_vm.textContent)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }